module.exports = __webpack_public_path__ + "img/script.64a983f1.png";